import type Handsontable from 'handsontable';

type HandsontableWithView = Handsontable & {
  view?: {
    adjustElementsSize?: (flush?: boolean) => void;
  };
};

/**
 * Полностью синхронизирует размеры master-таблицы и её overlay-клонов.
 *
 * Одного refreshDimensions() недостаточно: Handsontable пропускает render,
 * когда округлённый bounding rect не изменился. Это встречается при canvas-
 * масштабе, browser zoom и структурных операциях (filter/sort/pagination),
 * хотя внутренняя геометрия строк и overlay уже могла устареть.
 */
export function synchronizeHotLayout(hot: Handsontable | null | undefined): void {
  if (!hot || hot.isDestroyed) return;

  (hot as HandsontableWithView).view?.adjustElementsSize?.(true);
  hot.refreshDimensions();
  hot.render();
}
